import { gql } from "@apollo/client"
import { ContextoGlobalInterface } from "../../GlobalStates/ContextoGlobal"
import { LayoutStateInterface } from "../../GlobalStates/LayoutState"

export default class ClsPesquisaClienteAtual {

  public setarDescricaoCliente (
    idCliente: number,
    contextoGlobal: ContextoGlobalInterface,
    layoutState: LayoutStateInterface,
    setLayoutState: React.Dispatch<React.SetStateAction<LayoutStateInterface>>
  ) {

    if ( idCliente !== 0 ) {

      const query: string = `
        getClientePorId (idCliente: ${idCliente}) {
          nomeFantasia
        }
      `

      contextoGlobal.apolloClient
        .query( {
          query: gql( `query { ${query} }` )
        } ).then( rs => {
          setLayoutState( { ...layoutState, descricaoClienteAtual: rs.data.getClientePorId.nomeFantasia } )
        } )

    } else {
      setLayoutState( { ...layoutState, descricaoClienteAtual: 'Escolha a Empresa' } )
    }

  }

}